export default {
  index: {
    rechargeGame: "儲值遊戲",
    quickRecharge: "快速儲值",
    history: "歷史記錄",
  },
  component: {
    history: {
      title: "系統自動記錄您最近的儲值記錄",
      loadingText: "數據加載中",
      detail: {
        title: "訂單詳情",
        product_name: "品項",
        custom_content: "獎勵內容",
        game_name: "遊戲",
        server_name: "伺服器",
        roleid: "角色ID",
        pay_title: "儲值方式",
        money: "儲值金額",
        order_id: "訂單號",
        pay_time: "時間",
        coupon_code: "優惠碼",
        all_ratio: "贈送比例",
      },
      filters: {
        notRecharged: "未儲值",
        rechargedSuccess: "儲值成功",
        rechargedError: "儲值失敗",
      },
    },
    quickRecharge: {
      loadingText: "數據加載中",
      title: "訂單詳情",
      product_name: "品項",
      custom_content: "獎勵內容",
      game_name: "遊戲",
      server_name: "伺服器",
      roleid: "角色ID",
      pay_title: "儲值方式",
      money: "儲值金額",
      order_id: "訂單號",
      pay_time: "時間",
      coupon_code: "優惠碼",
      all_ratio: "贈送比例",
      button: {
        rechargeOrder: "快速儲值該訂單",
      },
    },
    rechargeGame: {
      loadingText: "數據加載中",
      noDataText: "無數據",
      gameForm: {
        title: "角色信息",
        gamePlaceholder: "請選擇遊戲",
        serverPlaceholder: "請選擇伺服器",
        usernamePlaceholder: "角色名字",
      },
      infoForm: {
        title: "儲值信息",
        region: "選擇地區",
        placeholder: "請選擇地區或國家",
      },
      typeForm: {
        title: "儲值方式",
        // 韩文这两个不一样所以选用两个字段
        placeholder: "請選擇",
        channelPlaceholder: "請選擇",
      },
      item: {
        title: "儲值品項",
      },
      detail: {
        title: "訂單詳情", //
        game_name: "遊戲", //
        server_name: "伺服器", //
        roleid: "角色ID", //
        pay_title: "儲值方式", //
        money: "儲值金額", //
        product_title: "儲值品項",
        custom_content: "獎勵內容",
        remind_content: "提醒",
        coupon_code: "優惠碼", //
        couponCodePlaceholder: "請輸入使用的優惠碼",
        all_ratio: "贈送比例", //
        // tips: "贈送獎勵均為遊戲幣",
        button: "确定",
      },
      methods: {
        dataErrorMsg: "數據請求錯誤",
        itemErrorMsg: "請選擇一個品項",
        serverErrorMsg: "伺服器出錯",
        couponCodeSuccessMsg: "可以使用的優惠碼",
      },
    },
  },
};
